/* ============================================================
   PORTFOLIO DATA — dummy content.
   Replace with data fetched from GitHub / a CMS / an API later.
   Keep the shape the same and the rest of the app keeps working.
   ============================================================ */

export const PROFILE = {
  name: "Badusha Pareed",
  shortName: "Badu",
  role: "Developer $ Designer",
  location: "Ernakulam, Kerala",
  host: "badu",
  user: "guest",
};

export const ABOUT = {
  bio: [
  "I'm Badusha, a Computer Science graduate who likes turning",
  "ideas into software — mostly through frontend, Flutter,",
  "and the occasional machine learning or security project.",

  "",

  "I care about interfaces that feel intentional, code that stays",
  "simple, and products that solve an actual problem.",

  "",

  "When I'm away from the screen, you'll probably find me",
  "behind a camera. Photography is how I usually unwind.",
],
  facts: [
    ["role", PROFILE.role],
    ["based_in", PROFILE.location],
    ["focus", "Full-stack web & mobile development"],
    ["status", "OPEN_TO_WORK"],
  ],
};

export const STACK = {
  languages: ["Java", "JavaScript", "Python", "dart", "SQL", "HTML"],
  frontend: ["React", "Flutter", "Tailwind CSS", "Framer Motion"],
  backend: ["Node.js", "Express", "PostgreSQL", "Redis"],
  tools: ["Git", "Docker", "Figma", "Android Studio", "Linux"],
};

export const EXPERIENCE = [
  {
    role: "Creative Lead",
    company: "muLearn & IEDC",
    period: "2022 — Present",
    points: [
      "Led creative teams and contributed to branding, visual design, and event experiences",
      "Worked with teams to turn ideas into engaging digital and visual content",
    ],
  },

  {
    role: "Graphic Design Intern",
    company: "PlaySpots",
    period: "Internship",
    points: [
      "Created graphics and visual content for digital and marketing requirements",
      "Worked on a variety of design tasks while gaining experience in a professional environment",
    ],
  },

  {
    role: "Flutter & Fullstack Developer",
    company: "Personal & Academic Projects",
    period: "2022 — Present",
    points: [
      "Built applications using Flutter, React, Python, and FastAPI",
      "Explored AI/ML and cybersecurity through academic projects, personal builds, and hackathons",
    ],
  },

  {
    role: "UI/UX Designer",
    company: "Academic & Personal Projects",
    period: "2022 — Present",
    points: [
      "Designed practical interfaces with a focus on simplicity, usability, and clear visual hierarchy",
      "Used Figma to prototype and refine ideas before turning them into working products",
    ],
  },

  {
    role: "Freelance Photographer",
    company: "Independent",
    period: "Previous",
    points: [
      "Photographed portraits, events, and everyday moments for personal and freelance work",
      "Developed an eye for composition, lighting, and visual storytelling",
    ],
  },
];

/* Each project doubles as a "file": ls shows the slug, cat <slug> shows readme */
export const PROJECTS = [
  {
    slug: "flowbase",
    name: "flowbase",
    desc: "Visual workflow builder for internal tools",
    tech: ["React", "TypeScript", "tRPC"],
    status: "LIVE",
    link: "https://github.com/",
    readme: [
      "flowbase is a drag-and-drop workflow builder used by internal",
      "ops teams to automate multi-step approval flows without writing",
      "code. Started as a weekend prototype, now runs in production.",
      "",
      "Highlights:",
      "- Node-based canvas built on a custom graph engine",
      "- Real-time collaboration via CRDT sync",
      "- 40+ integrations (Slack, email, webhooks, internal APIs)",
    ],
  },
  {
    slug: "termfolio",
    name: "termfolio",
    desc: "This portfolio — a command-driven terminal UI",
    tech: ["React", "Tailwind"],
    status: "LIVE",
    link: "https://github.com/",
    readme: [
      "The site you're looking at. A macOS-style terminal window",
      "rendered in the browser, driven entirely by typed commands.",
      "",
      "Highlights:",
      "- Draggable, minimizable, fullscreen-toggleable window chrome",
      "- Fake filesystem: cd / ls / cat across sections",
      "- Fully modular, data-driven — content lives in one file",
    ],
  },
  {
    slug: "palette-cli",
    name: "palette-cli",
    desc: "Generate accessible color systems from the command line",
    tech: ["Node.js", "Chalk"],
    status: "ARCHIVED",
    link: "https://github.com/",
    readme: [
      "A CLI that takes a base color and spits out a full accessible",
      "palette (contrast-checked against WCAG AA) as CSS variables,",
      "Tailwind config, or JSON.",
      "",
      "Archived in favor of building the same logic directly into",
      "design tooling at Nimbus Labs.",
    ],
  },
];

export const ONGOING = [
  {
    slug: "orbit",
    name: "orbit",
    desc: "Local-first note tool with git-based sync",
    tech: ["Rust", "Tauri"],
    progress: "62%",
    readme: [
      "orbit is a local-first notes app that uses git as its sync",
      "layer instead of a proprietary backend — every note is a",
      "markdown file, every sync is a commit.",
      "",
      "In progress:",
      "- Conflict resolution UI for simultaneous edits",
      "- Mobile companion app",
    ],
  },
  {
    slug: "shelf",
    name: "shelf",
    desc: "Minimal read-later app for the terminal",
    tech: ["Go", "Bubbletea"],
    progress: "30%",
    readme: [
      "A read-later queue that lives entirely in your terminal.",
      "Save a link, shelf strips it down to readable text and",
      "stores it locally for offline reading.",
      "",
      "In progress:",
      "- Full-text search across saved articles",
      "- Tagging and collections",
    ],
  },
];

export const CONTACT = {
  email: "hi.badushapareed@gmail.com",
  github: "github.com/badu01",
  instagram: "instagram.com/b.a.d.u._",
  linkedin: "linkedin.com/in/badusha-pareed",
  site: "badushapareed.in",
};